import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface EmailFailureDialogData {
  failures: string[];
}

@Component({
  selector: 'mode-email-failure-dialog',
  templateUrl: './email-failure-dialog.component.html',
  styleUrls: ['./email-failure-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailFailureDialogComponent {
  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: EmailFailureDialogData,
    public dialogRef: MatLegacyDialogRef<EmailFailureDialogComponent>
  ) {}
}
